import React from 'react';
import { TableHead, TableRow, TableCell, Typography } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import MultipleProgressBar from '../../../CustomComponents/MultipleProgressBar';
import { theme } from '../../../../theme';
import OverdueChip from '../../OverdueChip';
import ProgressTooltip from '../Physicians/ProgressTooltip';
import { Box } from '@mui/system';


function CardManagerFooter(props) {
    const totalOpportunityValue = props.summaryStats.total_opportunity_value;
    const totalNumRecs = props.summaryStats.total_opportunity_recs;
    const totalApprovedValue = props.summaryStats.total_approved_value;
    const totalApprovedPercentage = Math.round((totalApprovedValue / Math.max(totalOpportunityValue, 1)) * 100);
    const totalNumApproved = props.summaryStats.total_approved_recs;
    const countApprovedPercentage = Math.round((totalNumApproved / Math.max(totalNumRecs, 1)) * 100);
    const totalDeniedValue = props.summaryStats.total_rejected_value;
    const totalDeniedPercentage = Math.round((totalDeniedValue / Math.max(totalOpportunityValue, 1)) * 100);
    const totalNumDenied = props.summaryStats.total_rejected_recs;
    const countDeniedPercentage = Math.round((totalNumDenied / Math.max(totalNumRecs, 1)) * 100);
    const totalUnreviewedValue = props.summaryStats.total_open_value;
    const totalUnreviewedPercentage = Math.round((totalUnreviewedValue / Math.max(totalOpportunityValue, 1)) * 100);
    const totalNumUnreviewed = props.summaryStats.total_open_recs;
    const countUnreviewedPercentage = Math.round((totalNumUnreviewed / Math.max(totalNumRecs, 1)) * 100);
    const totalOverdueValue = props.summaryStats.total_overdue_value;
    const totalOverduePercentage = Math.round((totalOverdueValue / Math.max(totalOpportunityValue, 1)) * 100);
    const totalNumOverdue = props.summaryStats.total_overdue_recs;
    const countOverduePercentage = Math.round((totalNumOverdue / Math.max(totalNumRecs, 1)) * 100);

    return (
        <TableHead sx={{ bottom: 0, left: 0, position: 'sticky', zIndex: 2 }}>
            <TableRow className="tableFooter" sx={{ textOverflow: 'ellipsis', overflow: 'hidden', color: 'black', height: '60px', borderTop: '1px solid #DDD'}}>
                <TableCell>
                    <Typography variant='heavy' fontSize='12px'>
                        <strong>{props.totalManagers} Total</strong>
                    </Typography>
                </TableCell>
                <TableCell >
                    <ProgressTooltip 
                        acceptedCount={totalNumApproved} 
                        acceptedValue={totalApprovedValue / 100} 
                        deniedCount={totalNumDenied} 
                        deniedValue={totalDeniedValue / 100} 
                        unreviewedCount={totalNumUnreviewed} 
                        unreviewedValue={totalUnreviewedValue / 100}
                    >
                        <Box>
                            <MultipleProgressBar segments={[
                                {
                                    value: totalApprovedPercentage,
                                    color: `${theme.palette.blue.main}`
                                },
                                {
                                    value: totalDeniedPercentage,
                                    color: `${theme.palette.background.deniedProgress}`
                                },
                                {
                                    value: totalUnreviewedPercentage,
                                    color: `${theme.palette.background.unreviewedProgress}`
                                }
                            ]} label={props.numericFormat === 'currency' ? 
                                <strong>{`$${Math.round((totalOpportunityValue - totalUnreviewedValue) / 100 / 1000)}k / $${Math.round(totalOpportunityValue / 100 / 1000)}k (${100 - totalUnreviewedPercentage}%)`}</strong> : 
                                <strong>{`${totalNumRecs - totalNumUnreviewed} / ${totalNumRecs} Optimizations (${100 - countUnreviewedPercentage}%)`}</strong>
                            } />
                        </Box>
                    </ProgressTooltip>
                </TableCell>
                <TableCell>
                    <Typography variant='heavy' fontSize='12px'>
                        <strong>
                            { props.numericFormat === 'currency' &&
                                <NumericFormat value={totalApprovedValue / 100} displayType={'text'} thousandSeparator={true} prefix={'$'} suffix={` (${totalApprovedPercentage}%)`} decimalScale={0} fixedDecimalScale />
                            }
                            { props.numericFormat === 'count' &&
                                `${totalNumApproved} Optimizations (${countApprovedPercentage}%)`
                            }
                        </strong>
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography variant='heavy' fontSize='12px'>
                        <strong>
                            { props.numericFormat === 'currency' &&
                                <NumericFormat value={totalDeniedValue / 100} displayType={'text'} thousandSeparator={true} prefix={'$'} suffix={` (${totalDeniedPercentage}%)`} decimalScale={0} fixedDecimalScale />
                            }
                            { props.numericFormat === 'count' &&
                                `${totalNumDenied} Optimizations (${countDeniedPercentage}%)`
                            }
                        </strong>
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography variant='heavy' fontSize='12px'>
                        <strong>
                            { props.numericFormat === 'currency' &&
                                <NumericFormat value={totalUnreviewedValue / 100} displayType={'text'} thousandSeparator={true} prefix={'$'} suffix={` (${totalUnreviewedPercentage}%)`} decimalScale={0} fixedDecimalScale />
                            }
                            { props.numericFormat === 'count' &&
                                `${totalNumUnreviewed} Optimizations (${countUnreviewedPercentage}%)`
                            }
                        </strong>
                    </Typography>
                </TableCell>
                <TableCell sx={{ textAlign: 'right' }}>
                    <OverdueChip
                        overdueValue={totalOverdueValue}
                        numOverdue={totalNumOverdue}
                        overduePercentage={totalOverduePercentage}
                        numOverduePercentage={countOverduePercentage}
                        format={props.numericFormat}
                    />
                </TableCell>
            </TableRow>
        </TableHead>
    )
}

export default CardManagerFooter;
